export const STORAGE_KEYS = {
  UNSAVED_DTC_CHANGES: 'unsavedDtcChanges',
  UNSAVED_DTC_REVIEW_REQUEST_CHANGES: 'unsavedDtcReviewRequestChanges',
  UNSAVED_ERROR_MESSAGE_CHANGES: 'unsavedErrorMessageChanges',
  UNSAVED_LINKED_DTCS_CHANGES: 'unsavedLinkedDtcsChanges',
  UNSAVED_ERROR_CODE_CHANGES: 'unsavedErrorCodeChanges',
  UNSAVED_SW_PART_NUMBER: 'unsavedSwPartNumber',
  UNSAVED_PROJECT: 'unsavedProjectChanges',
  UNSAVED_NW_NUMBER: 'unsavedNwNumber',
  NONE: 'NONE',
  SW_PART_NUMBER: 'swPartNumber',
  SIDEBAR_WIDTH: 'sidebarWidth',
  LANGUAGE: 'language',
};
